import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import {Product} from '../../modals/product.model';
import {CartItem} from '../../modals/cart-item';
import {ProductService} from '../shared/services/product.service';
import {CartService} from '../shared/services/cart.service';
import { Router, NavigationEnd } from '@angular/router';
import { SidebarMenuService } from '../shared/sidebar/sidebar-menu.service';
import { SidenavMenu } from '../shared/sidebar/sidebar-menu.model';
import { AuthService } from '../auth/auth.service';
import { AuthGuard } from '../auth/auth-guard.service';
import { ScrollService } from '../shared/services/scroll.service';
import { SharedMethods } from '../shared/services/sharedMethods-service';
import { MatSidenav } from '@angular/material';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, AfterViewInit {

  public sidenavMenuItems:Array<any>;

  public currencies = ['USD', 'EUR'];
  public currency:any;
  public flags = [
    { name:'English', image: 'assets/images/flags/gb.svg' },
    { name:'German', image: 'assets/images/flags/de.svg' },
    { name:'French', image: 'assets/images/flags/fr.svg' },
    { name:'Russian', image: 'assets/images/flags/ru.svg' },
    { name:'Turkish', image: 'assets/images/flags/tr.svg' }
  ]
  public flag:any;

  products: Product[];

  indexProduct: number;
  shoppingCartItems: CartItem[] = [];

  public banners = [];

  wishlistItems  :   Product[] = [];

  public url : any;

  navItems: SidenavMenu[] = [];
  
  navItemsDefault: SidenavMenu[] = [

    {
      displayName: 'Documents',
      iconName: '',
      route: '/home/products/all',
      param: 'type',
      paramvalue:'doc',
    },
    {
      displayName: 'Audios',
      iconName: '',
      route: '/home/products/all',
      param: 'type',
      paramvalue:'audio',
    },
    {
      displayName: 'Vidéos',
      iconName: '',
      route: '/home/products/all',
      param: 'type',
      paramvalue:'video',
    },
    {
      displayName: 'Programmes',
      iconName: '',
      route: '/home/products/all',
      param: 'type',
      paramvalue:'prog',
    },
    {
      displayName: 'Publier',
      iconName: '',
      route: '/pages/store',
    },
    {
      displayName: 'Mon compte',
      iconName: '',
      children: [
        {
          displayName: 'Profil',
          iconName: '',
          route: '/pages/setting'
        },
        {
          displayName: 'Mes publications',
          iconName: '',
          route: '/pages/store'
        },
        {
          displayName: 'Mes souscriptions',
          iconName: '',
          route: '/pages/downloads'
        },
        {
          displayName: 'Reçues commandes',
          iconName: '',
          route: '/pages/orders',
        },
      ]
    },
    /* {
      displayName: 'Mes Favoris',
      iconName: '',
      route: '/pages/wishlist'
    },
    {
      displayName: 'Blog',
      iconName: '',
      route: '/home/index'
    },
    {
      displayName: 'Contact',
      iconName: '',
      route: '/pages/contact'
    },
    {
      displayName: 'Comment achéter ?',
      iconName: '',
      route: '/home/index'
    },
    {
      displayName: 'Politique de retour',
      iconName: '',
      route: '/home/index'
    },
    {
      displayName: 'Frais de livraison',
      iconName: '',
      route: '/home/index'
    }, */
  ]


  /* navItems: SidenavMenu[] = [
    {
      displayName: 'Home',
      iconName: 'recent_actors',
      children: [
        {
          displayName: 'Home-1',
          iconName: 'group',
          route: '/home/one'
        },
        {
          displayName: 'Home-2',
          iconName: 'speaker_notes',
          route: '/home/two',
        },
        {
          displayName: 'Home-3',
          iconName: 'feedback',
          route: '/home/three'
        }
      ]
    },
    {
      displayName: 'Products',
          iconName: 'feedback',
          route: '/home/products/all'
    },
    {
      displayName: 'Shop',
      iconName: 'movie_filter',
      children: [
        {
          displayName: 'Computers',
          iconName: 'group',
          children: [
            {
              displayName: 'Laptops',
              iconName: 'person',
              route: 'michael-prentice',
            },
            {
              displayName: 'Cables',
              iconName: 'person',
              route: 'stephen-fluin',
               },
            {
              displayName: 'Monitors',
              iconName: 'person',
              route: 'mike-brocchi',
           },
           {
            displayName: 'Tablets',
            iconName: 'person',
            route: 'mike-brocchi',
         },
         {
          displayName: 'Headsets',
          iconName: 'person',
          route: 'mike-brocchi',
       }
          ]
        },
        {
          displayName: 'Tv & Audio',
          iconName: 'speaker_notes',
          children: [
            {
              displayName: 'Tv',
              iconName: 'star_rate',
              route: 'material-design'
            },
            {
              displayName: 'Audio',
              iconName: 'star_rate',
              route: 'what-up-web'
            },
            {
              displayName: 'Video',
              iconName: 'star_rate',
              route: 'my-ally-cli'
            },
            {
              displayName: 'Dvd',
              iconName: 'star_rate',
              route: 'become-angular-tailer'
            }
          ]
        },
        {
          displayName: 'Phones',
          iconName: 'feedback',
          children: [
            {
              displayName: 'Mobile phones',
              iconName: 'star_rate',
              route: 'material-design'
            },
            {
              displayName: 'Power Bank',
              iconName: 'star_rate',
              route: 'what-up-web'
            },
            {
              displayName: 'Memory Cards',
              iconName: 'star_rate',
              route: 'my-ally-cli'
            },
            {
              displayName: 'Accesories',
              iconName: 'star_rate',
              route: 'become-angular-tailer'
            }
          ]
        },
        {
          displayName: 'Electronics',
          iconName: 'feedback',
          children: [
            {
              displayName: 'Washing Machines',
              iconName: 'star_rate',
              route: 'material-design'
            },
            {
              displayName: 'Water heater',
              iconName: 'star_rate',
              route: 'what-up-web'
            },
            {
              displayName: 'Cookers',
              iconName: 'star_rate',
              route: 'my-ally-cli'
            },
            {
              displayName: 'Cold stores',
              iconName: 'star_rate',
              route: 'become-angular-tailer'
            }
          ]
        }
      ]
    },
    {
      displayName: 'Blog',
      iconName: 'report_problem',
      children: [
        {
          displayName: 'Blog List',
          iconName: 'group',
          route: '/blog/blog-list'
        },
        {
          displayName: 'Blog Columns',
          iconName: 'speaker_notes',
          route: '/blog/blog-column',
        },
        {
          displayName: 'Blog Details',
          iconName: 'feedback',
          route: '/blog/blog-details'
        }
      ]
    },
    {
      displayName: 'Pages',
      iconName: 'report_problem',
      children: [
        {
          displayName: 'About Us',
          iconName: 'group',
          route: '/pages/about'
        },
        {
          displayName: 'FAQ',
          iconName: 'speaker_notes',
          route: '/pages/faq',
        },
        {
          displayName: 'Contact',
          iconName: 'feedback',
          route: '/pages/contact'
        },
        {
          displayName: 'Wishlist',
          iconName: 'group',
          route: '/pages/wishlist'
        },
        {
          displayName: 'Compare',
          iconName: 'speaker_notes',
          route: '/pages/compare',
        },
        {
          displayName: 'Checkout',
          iconName: 'feedback',
          route: '/pages/checkout'
        },
        {
          displayName: 'Cart',
          iconName: 'group',
          route: '/pages/cart'
        },
        {
          displayName: 'My Account',
          iconName: 'speaker_notes',
          route: '/pages/my-account',
        },
        {
          displayName: '404',
          iconName: 'feedback',
          route: '/pages/error'
        }
      ]
    },
    {
      displayName: 'Contact',
          iconName: 'feedback',
          route: '/pages/contact'
    }
  ]; */

  helpcontact = '';
  email = '';

  @ViewChild('start') public inputSideNav: MatSidenav;

  // tslint:disable-next-line:max-line-length
  constructor(private productService: ProductService, private sharedMethods: SharedMethods, public router: Router, public scrollService: ScrollService, private cartService: CartService, public authGuard: AuthGuard, public authService: AuthService, public sidenavMenuService:SidebarMenuService, public sideBarMenuService: SidebarMenuService) {
    this.cartService.getItems().subscribe(shoppingCartItems => this.shoppingCartItems = shoppingCartItems);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.url = event.url;
      }
    } )


    if(this.sharedMethods.cacheSettings === undefined) {

      this.sharedMethods.getSettings().subscribe(setting => {
        this.sharedMethods.cacheSettings = setting;
        this.helpcontact = this.sharedMethods.cacheSettings.helpcontact;
        this.email = this.sharedMethods.cacheSettings.email;
      });

    } else {

      this.helpcontact = this.sharedMethods.cacheSettings.helpcontact;
      this.email = this.sharedMethods.cacheSettings.email;

    }


    if(this.productService.cacheProduct.length === 0) {

      this.productService.getProducts().subscribe((product: Product[]) => {

          this.productService.cacheProduct = product;
          // this.generateMenuCat(this.productService.getCategories(this.productService.cacheProduct));

      });

    } else {

          // this.generateMenuCat(this.productService.getCategories(this.productService.cacheProduct));

    }

    this.productService.category().subscribe((cats: any) => {

        console.log(cats);
        this.generateMenuCat(cats);

    });

  }

  ngAfterViewInit() {

    this.cartService.sideNavShopping = this.inputSideNav;
    // console.log(this.cartService.sideNavShopping);

  }

  ngOnInit() {

    this.sideBarMenuService.drawerSibebarEvent.subscribe( event => {
      this.inputSideNav.close();
    });

    this.currency = this.currencies[0];
    this.flag = this.flags[0];
  }

  public generateMenuCat(cats: SidenavMenu) {

    // const test: SidenavMenu[] = cats;
    this.navItems.push({
      displayName: 'Accueil',
      iconName: '',
      route: '/home/index',
    }, {
      displayName: 'Toutes les ressources',
      iconName: '',
      route: '/home/products/all',
    });
    
    this.navItems.push(cats);

   


    this.navItemsDefault.forEach( elem => {
      this.navItems.push(elem);
    });
    // console.log(cats);
    

    /* if( cats !== null && cats !== undefined) {

      const menuCat = [{
        displayName: 'Tous les produits',
        iconName: 'speaker_notes',
        route: '/home/products/all',
      }];

      cats.forEach(elem => {

        menuCat.push({
          displayName: elem,
          iconName: 'speaker_notes',
          route: '/home/products/' + this.sharedMethods.generateSlug(elem),
        });


      });

      // this.navItems[2].children = menuCat;

    } */

  }

  public changeCurrency(currency){
    this.currency = currency;
  }
  public changeLang(flag){
    this.flag = flag;
  }

  goToParameter() {
    this.router.navigate(['pages/setting']);
  }

  goToDashbord() {
    this.router.navigate(['pages/dashbord']);
  }

  goToOrders() {
    this.router.navigate(['pages/orders']);
  }

  // évènement appélé sur le  <router-outlet (deactivate)="scrollToTop($event)"></router-outlet>
  scrollToTop() {
    // alert('hfhn');
    /* if ( event.constructor.name === 'login' ) { // for example
          window.scroll(0,0);
    } */

    // document.body.scrollTop = 0;
    this.scrollService.scrollToTop();
  }

  routeDesactivate(event) {
    // console.log(this.cartService.sideNavShopping);
    this.inputSideNav.close();
    this.scrollToTop();
  }

}
